import React, { useEffect, useState } from 'react';
import LinkAdaptativo from '../UI/LinkAdaptativo.js';
import * as AgrupacionesTorneos from '../constantes/AgrupacionesTorneos.js';
import BotoneraFiltros from '../UI/BotoneraFiltros.js';
import MensajeCargando from '../UI/MensajeCargando.js';
import MensajeError from '../UI/MensajeError.js';
import Paginador from '../UI/Paginador.js';
import TablaDatos from '../UI/TablaDatos.js';
import { ListaPartidos } from '../constantes/Filtros.js';
import * as ModoPersona from '../constantes/ModoPersona.js';
import * as TipoEquipo from '../constantes/TipoEquipo.js';
import * as UI from '../constantes/UI.js';
import * as DataPartidos from '../data/DataPartidos.js';
import * as Fecha from '../funciones/FuncionesFecha.js';
import { ResultadoPartidoEquipos } from '../funciones/FuncionesPartidos.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './TablaPartidosPersona.module.css';

const filtroPartidos = [
  { codigo: AgrupacionesTorneos.LIGAS_NACIONALES, descripcion: 'Liga Nacional' },
  { codigo: AgrupacionesTorneos.COPAS_NACIONALES, descripcion: 'Copas Nacionales' },
  { codigo: AgrupacionesTorneos.INTERNACIONALES, descripcion: 'T.Internacional' },
  { codigo: ListaPartidos.AMISTOSOS, descripcion: 'Amistosos' },
  { codigo: ListaPartidos.SELECCION, descripcion: 'Selección' },
];

const TablaPartidosPersona = (props) => {
  const idPersona = props.persona && props.persona.id;
  const modo = props.modo;
  const [partidos, setPartidos] = useState(null);
  const [cantPaginas, setCantPaginas] = useState(null);
  const [pagina, setPagina] = useState(0);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const [filtro, setFiltro] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const incSuplente = true; //TODO: option incluir partidos suplente

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  // Detectar cambios de tamaño de pantalla
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    // Establecer en el primer render después del mount
    // Esto asegura que funciona en producción
    setIsMobile(window.innerWidth < 1024);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const getTotalPartidos = async () => {
      let total;
      switch (modo) {
        case ModoPersona.ARBITRO: {
          total = await DataPartidos.GetTotalPartidosArbitro(idPersona, filtro);

          break;
        }
        case ModoPersona.JUGADOR: {
          total = await DataPartidos.GetTotalPartidosJugador(idPersona, filtro);

          break;
        }
        case ModoPersona.TECNICO: {
          total = await DataPartidos.GetTotalPartidosTecnico(idPersona, filtro);

          break;
        }
        default: {
          total = await DataPartidos.GetTotalPartidosPersona(idPersona, filtro);
        }
      }
      if (total !== null && total !== Promise.resolve(total)) {
        setCantPaginas(Math.floor(total / UI.PARTIDOS_X_PAGINA) + 1);
      }
    };
    if (idPersona !== null) {
      getTotalPartidos();
    }
  }, [fetchData, idPersona, modo, filtro]);

  useEffect(() => {
    if (idPersona === null) {
      setPartidos(null);
    } else {
      let url = '';
      switch (modo) {
        case ModoPersona.ARBITRO: {
          url = 'personas_arbitro';

          break;
        }
        case ModoPersona.JUGADOR: {
          url = 'jugadores';

          break;
        }
        case ModoPersona.TECNICO: {
          url = 'tecnicos';

          break;
        }
        default: {
          url = 'personas';
        }
      }
      url += '/' + idPersona + '/partidos';
      if (filtro === ListaPartidos.AMISTOSOS) {
        url += '/amistosos';
      }
      url += '?incluirSuplente=' + (incSuplente ? 'true' : 'false');
      if (filtro !== null) {
        if (filtro === ListaPartidos.SELECCION) {
          url += '&tipoEquipo=' + TipoEquipo.SELECCION;
        } else if (filtro > 0) {
          url += '&codAgrupacion=' + filtro;
        }
      }
      url += '&pagina=' + pagina + '&items=' + UI.PARTIDOS_X_PAGINA;
      fetchData(url, setPartidos);
    }
  }, [fetchData, idPersona, filtro, incSuplente, pagina, modo]);

  const onFiltroElegido = (filtro) => {
    setFiltro(Number(filtro));
  };

  const onPaginaElegida = (pagina) => {
    setPagina(pagina);
  };

  let textoVacia = 'No hay partidos cargados para ';
  switch (modo) {
    case ModoPersona.ARBITRO: {
      textoVacia += 'el árbitro';

      break;
    }
    case ModoPersona.JUGADOR: {
      textoVacia += 'el jugador';

      break;
    }
    case ModoPersona.TECNICO: {
      textoVacia += 'el técnico';

      break;
    }
    default: {
      textoVacia += 'la persona';
    }
  }

  return (
    <React.Fragment>
      <BotoneraFiltros
        filtros={filtroPartidos}
        selected={filtro}
        onFiltroElegido={onFiltroElegido}
        onResetPagina={setPagina}
      />
      {partidos && !isCargando && (
        <React.Fragment>
          <TablaDatos estilo={`${styles.tablaPartidos}`} lista={partidos} textoVacia={textoVacia}>
            {isMobile ? (
              // Mobile: agrupar por torneo
              <tbody>
                {(() => {
                  // Agrupar partidos por torneo
                  const partidosPorTorneo = {};
                  partidos.forEach((partido) => {
                    if (!partidosPorTorneo[partido.motivo]) {
                      partidosPorTorneo[partido.motivo] = [];
                    }
                    partidosPorTorneo[partido.motivo].push(partido);
                  });

                  // Renderizar agrupados
                  return Object.keys(partidosPorTorneo).map((torneo) => (
                    <React.Fragment key={torneo}>
                      <tr className={`${styles.tituloTorneo}`}>
                        <td colSpan="2">{torneo}</td>
                      </tr>
                      {partidosPorTorneo[torneo].map((partido) => (
                        <tr key={partido.id}>
                          <td className={`${styles.valor}`}>
                            {Fecha.CamposToFechaCorta(
                              partido.anioPartido,
                              partido.mesPartido,
                              partido.diaPartido
                            )}
                          </td>
                          <td className={`${styles.valor}`}>
                            <LinkAdaptativo to={'/partido/' + partido.id} external={true}>
                              {ResultadoPartidoEquipos(partido)}
                            </LinkAdaptativo>
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ));
                })()}
              </tbody>
            ) : (
              // Desktop: tabla normal
              <tbody>
                <tr key="0">
                  <td>Fecha</td>
                  <td>Torneo</td>
                  <td>Resultado</td>
                </tr>
                {partidos.map((partido) => (
                  <tr key={partido.id}>
                    <td className={`${styles.valor}`}>
                      {Fecha.CamposToFechaCorta(
                        partido.anioPartido,
                        partido.mesPartido,
                        partido.diaPartido
                      )}
                    </td>
                    <td className={`${styles.valor}`}>{partido.motivo}</td>
                    <td className={`${styles.valor}`}>
                      <LinkAdaptativo to={'/partido/' + partido.id} external={true}>
                        {ResultadoPartidoEquipos(partido)}
                      </LinkAdaptativo>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </TablaDatos>
          <Paginador
            cantPaginas={cantPaginas}
            cantBotones="5"
            paginaActual={pagina}
            onPaginaElegida={onPaginaElegida}
          />
        </React.Fragment>
      )}
      <MensajeCargando estilo={`${styles.cargando}`} isCargando={isCargando} />
      <MensajeError estilo={`${styles.error}`} errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default TablaPartidosPersona;
